// Deal Actions
export const getDealsTable = (payload) => ({
  payload,
  type: 'GET_DEALS_TABLE',
})

export const setDealsTable = (payload) => ({
  payload,
  type: 'SET_DEALS_TABLE',
})

export const getPipelineBoard = (payload) => ({
  payload,
  type: 'GET_PIPELINE_BOARD',
})

export const setPipelineBoard = (payload) => ({
  payload,
  type: 'SET_PIPELINE_BOARD',
})

export const moveDealStage = (payload) => ({
  payload,
  type: 'MOVE_DEAL_STAGE',
})

export const getSingleDeal = (payload) => ({
  payload,
  type: 'GET_SINGLE_DEAL',
})

export const setLoading = (payload) => ({
  payload,
  type: 'DEALS_LOADING',
})

export const setSingleDeal = (payload) => ({
  payload,
  type: 'SET_SINGLE_DEAL',
})

export const setNewDealModal = (payload) => ({
  payload,
  type: 'SET_NEW_DEAL_MODAL',
})

export const setAdvanceFilter = (payload) => ({
  payload,
  type: 'SET_ADVANCE_FILTER_MODULE',
})

// Removed - now using createObject and updateObject from Objects store

// Pipeline Actions
export const getPipelines = () => ({
  type: 'GET_PIPELINES',
})

export const setPipelines = (payload) => ({
  payload,
  type: 'SET_PIPELINES',
})

export const getPipelineById = (payload) => ({
  payload,
  type: 'GET_PIPELINE_BY_ID',
})

export const setPipelineById = (payload) => ({
  payload,
  type: 'SET_PIPELINE_BY_ID',
})

export const createPipeline = (payload) => ({
  payload,
  type: 'CREATE_PIPELINE',
})

export const updatePipeline = (payload) => ({
  payload,
  type: 'UPDATE_PIPELINE',
})

export const deletePipeline = (payload) => ({
  payload,
  type: 'DELETE_PIPELINE',
})

export const setPipelineSettingsModal = (payload) => ({
  payload,
  type: 'SET_PIPELINE_SETTINGS_MODAL',
})

export const setCreatePipelineModal = (payload) => ({
  payload,
  type: 'SET_CREATE_PIPELINE_MODAL',
})

export const getDealStats = (payload) => ({
  payload,
  type: 'GET_DEAL_STATS',
})
export const setDealStats = (payload) => ({
  payload,
  type: 'SET_DEAL_STATS',
})

// Pipeline Metrics
export const setPipelineMetrics = (payload) => ({
  payload,
  type: 'SET_PIPELINE_METRICS',
})

// Bulk Actions
export const bulkCreateDeals = (payload) => ({
  payload,
  type: 'BULK_CREATE_DEALS',
})

// Removed - now using bulkUpdateObjects from Objects store

export const toggleDeleteDeals = (payload) => ({
  payload,
  type: 'TOGGLE_DELETE_DEALS',
})

// Removed - now using bulkDeleteObjects from Objects store

// Import/Export Actions
export const importDeals = (payload) => ({
  payload,
  type: 'IMPORT_DEALS',
})

export const exportDeals = (payload) => ({
  payload,
  type: 'EXPORT_DEALS',
})

// View Actions (following contact pattern)
export const getDealViews = (payload) => ({
  payload,
  type: 'GET_DEAL_VIEWS',
})

export const setDealViews = (payload) => ({
  payload,
  type: 'SET_DEAL_VIEWS',
})

export const createDealView = (payload) => ({
  payload,
  type: 'CREATE_DEAL_VIEW',
})

export const updateDealView = (payload) => ({
  payload,
  type: 'UPDATE_DEAL_VIEW',
})

export const deleteDealView = (payload) => ({
  payload,
  type: 'DELETE_DEAL_VIEW',
})

// Filter Actions
export const setFilters = (payload) => ({
  payload,
  type: 'SET_DEAL_FILTERS',
})

export const setFilter = (payload) => ({
  payload,
  type: 'SET_DEAL_FILTER',
})

export const clearDealFilters = () => ({
  type: 'CLEAR_DEAL_FILTERS',
})

export const applyFilters = (payload) => ({
  payload,
  type: 'APPLY_DEAL_FILTERS',
})

